export default __webpack_public_path__ + "static/media/Snap1.e05078f3.mp3";